export const serviceCategoryAdapter =
    ({
         id,
         title,
         color,
         parent_id,
         clinic_id,
         technics,
         doctors,
         managers,
         assistants,
     }) => ({
        id: id ?? null,
        title: title ?? null,
        color: color ?? null,
        parent_id: parent_id ?? null,
        clinic_id,
        technics: minimizeUsers(technics, 'technics'),
        doctors: minimizeUsers(doctors, 'doctors'),
        managers: minimizeUsers(managers, 'managers'),
        assistants: minimizeUsers(assistants, 'assistants'),
    })


function minimizeUsers(users, role) {
    let data = {}
    if(!users) return data
    users.forEach(item => {
        if(item.id) {
            data[item.id] = {
                value: item.pivot.value,
                rate_type: item.pivot.rate_type,
                role,
                user_id: item.id
            }
        }
    })
    return data
}
